export default "__VITE_ASSET__CuaRyi_V__"